import * as Yup from "yup";

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const researchCentreSchema = Yup.object().shape({
  name: Yup.string().required("Research Centre name is required"),
  location: Yup.string().required("Location is required"),
  description: Yup.string().nullable(),
  institution_id: Yup.string().required("Institution is required"),
  research_areas: Yup.array()
    .of(Yup.string().matches(uuidRegex, "Research Area must be a valid UUID"))
    .min(1, "At least one Research Area is required"),
});
